<template>
  <v-container class="text-center card">
    <v-card>
      <v-card-title>
        <h3>Add New Post</h3>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3" ref="form" @submit.prevent="onSubmit">
          <v-row>
            <v-col lg="6">
              <!-- post title -->
              <v-text-field
              name="title"
              label="Title"
              v-model="title"
              id="title"
              prepend-icon="mdi-format-title"
              required
              ></v-text-field>
            </v-col>

            <!-- add image -->
            <v-col lg="2">
                <div class="text-center">
                  <v-dialog
                  v-model="dialog"
                  width="500"
                  >
                  <template v-slot:activator="{ on }">
                    <v-btn
                    color="pTeal"
                    dark
                    v-on="on"
                    >
                    Add Image
                  </v-btn>
                </template>

                <!-- on click popup -->
                <v-card>
                  <v-card-title
                  class="headline lightGrey"
                  primary-title
                  >
                  URL
                </v-card-title>

                <v-card-text>

                  <!-- add image -->
                  <v-form class="px-3" ref="form">
                    <v-text-field
                    label="Link"
                    name="imageURL"
                    v-model="imageUrl"
                    id="image-url"
                    prepend-icon="mdi-image"
                    ></v-text-field>
                    <input type="file" ref="fileInput" accept="image/*" @change="onChosen">
                  </v-form>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                  text
                  @click="dialog = false; submit"
                  >
                  Add
                </v-btn>
              </v-card-actions>

            </v-card>
          </v-dialog>
        </div>
    </v-col>
  </v-row>

  <!-- post image preview -->
  <v-row>
    <v-img
    :src="imageUrl"
    contain
    aspect-ratio="1.7"
    max-height="300px"
    ></v-img>
  </v-row>

  <!-- post content -->
  <v-textarea
  label="Text"
  name="Text"
  v-model="text"
  id="text"
  prepend-icon="mdi-pencil-box-outline"
  required
  ></v-textarea>

      <v-row cols="2">
        <v-select
          v-model="select"
          hint="Select Post Longevity"
          :items="items"
          item-text="state"
          label="Select"
          persistent-hint
          return-object
          single-line
        ></v-select>
      </v-row>

  <v-row>
    <v-switch v-model="publicP" label="Set to Public"></v-switch>

    <v-spacer></v-spacer>

    <v-btn class="mx-2" fab depressed text outlined color="indigo" :disabled="!formIsValid" type="submit" @click="onCreatePost">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
  </v-row>

</v-form>
</v-card-text>

</v-card>
</v-container>


</template>


<script>
export default {
  data: () => ({
    title: '',
    imageUrl: '',
    imageData:'',
    text:'',
    id:'',
    date:'',
    publicP: false,
    dialog: false,
    select: { state: 'Default - 1 month'},
        items: [
          { state: 'Default - 1 month'},
          { state: '5 mins'},
          { state: '1 hour'},
          { state: '1 day'},
          { state: '1 week'},
        ],
  }),
  computed: {
    formIsValid () {
      return this.title !== '' && this.text !== '';
    }
  },
  methods: {
    onCreatePost () {

        let toDelete
        if(this.select.state === 'Default - 1 month'){
          toDelete= new Date()
          toDelete.setMonth(toDelete.getMonth() + 1)
        }
        else if(this.select.state === '5 mins') {
          toDelete= new Date()
          toDelete.setMinutes(toDelete.getMinutes() + 5)
        }
        else if(this.select.state === '1 hour') {
          toDelete= new Date()
          toDelete.setMinutes(toDelete.getMinutes() + 60)
        }
        else if(this.select.state === '1 day') {
          toDelete= new Date()
          toDelete.setDate(toDelete.getDate() + 1)
        }
        else if(this.select.state === '1 week') {
          toDelete= new Date()
          toDelete.setDate(toDelete.getDate() + 7)
        }

      const postData = {
        title: this.title,
        imageUrl: this.imageUrl,
        imageData: this.imageData,
        text: this.text,
        date: '' + new Date(),
        public: this.publicP,
        timeDelete: '' + toDelete,
        imageFile: this.imageName,
      }
      this.$store.dispatch('createPost', postData)
      this.$router.push('/feed');
    },
    onChosen(event){
      const picture = event.target.files
      let pictureName = picture[0].name
      if(pictureName.lastIndexOf('.')<=0){
        alert('invalid')
      }
      const reader = new FileReader()
      reader.addEventListener('load',()=>{
        this.imageData = reader.result
        this.imageUrl = reader.result
      })
      reader.readAsDataURL(picture[0])
      this.imageName = picture[0]
    },
  },

}
</script>

<style lang="css" scoped>
.card {
  max-width: 60%;
}
</style>
